import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/surveyMonkey.css";
 
const SurveyMonkey = ({ userEmail, isOpen, onClose }) => {
  const scriptContainerRef = useRef(null); // Reference to the modal content
  const [isScriptAdded, setIsScriptAdded] = useState(false); // Track if the script has been added
 
  useEffect(() => {
    const scriptId = "smcx-sdk";
 
    // Add the script only once when the modal opens for the first time
    if (isOpen && !isScriptAdded) {
      const scriptElement = document.createElement("script");
      scriptElement.type = "text/javascript";
      scriptElement.async = true;
      scriptElement.id = scriptId;
 
      // Append the custom variable (email) to the SurveyMonkey script URL
      scriptElement.src = `https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd5o780mspMPKwElcYRC9bjo8s2JM_2FlBvbzdgyhFsqd34.js?email=${encodeURIComponent(
        userEmail
      )}`;
 
      // Append the script to the modal's content area
      if (scriptContainerRef.current) {
        scriptContainerRef.current.appendChild(scriptElement);
      }
 
      setIsScriptAdded(true); // Mark the script as added
    }
 
    // Cleanup function to remove the script when the modal is unmounted
    return () => {
      if (isScriptAdded) {
        const script = document.getElementById(scriptId);
        if (script) {
          script.remove();
        }
      }
    };
  }, [isOpen, userEmail, isScriptAdded]); // The effect only runs when isOpen or userEmail changes
 
 // If the modal is closed, don't render anything
 
  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      id="reviewModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="reviewModalLabel"
      aria-hidden={!isOpen}
      style={{ display: isOpen ? "block" : "none", zIndex: 1050 }}
    >
      {/* <div
        className="modal-dialog modal-dialog-rectangular modal-dialog-centered"
        role="document"
        style={{ maxWidth: "1200px", width: "100%" }}
      ></div>*/}
      <div
        className="modal show d-block"
        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        {" "}
        <div className="modal-dialog modal-dialog-rectangular modal-dialog-centered  ">
          <div className="modal-content">
            <div className="modal-header" style={{ position: "relative" }}>
              <div className="logo-outer-container logo-position-left top-padding">
                <span
                  className="logo-container notranslate"
                  style={{ width: "200px", height: "64px" }}
                >
                  <img
                    className="logo user-generated"
                    src="https://surveymonkey-assets.s3.amazonaws.com/survey/414921064/040dbc8a-8e1d-4160-b1e3-a5a9a38da41c.png"
                    style={{ width: "200px", height: "64px" }}
                    alt="SurveyMonkey Logo"
                  />
                </span>
              </div>
              {/* Close button */}
              <button
                type="button"
                id="closeModalButton"
                className="close"
                aria-label="Close"
                onClick={onClose}
              >
                <span aria-hidden="true" style={{ color: "red" }}>
                  &times;
                </span>
              </button>
            </div>
 
            <div
              className="modal-body"
              ref={scriptContainerRef}
              style={{ width: "100%", height: "500px" }}
            >
              {/* SurveyMonkey widget will be inserted here */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default SurveyMonkey;
 